<header class="header-page">
    <h1 class="header__page__content__title">
        Histórico de Empréstimos
    </h1>
</header>
<main class="main__content">
    <section class="content__header">
        <h2>Meus Empréstimos</h2>
        <filtro-dados [pageItens]="5" [totalItens]="tamanhoLista" (changeQuantidade)="onChangeQuantidadeItens($event)"
            *ngIf="myRequests && myRequests.length > 0">
        </filtro-dados>
    </section>
    <ng-template #naoPossuiEmprestimos>
        <section class="ngTemplateNaoPossui">
            <p>Você não Possui Empréstimos!</p>
        </section>
    </ng-template>
    <ng-template #showLoading>
        <spinner [show]="loading"></spinner>
    </ng-template>
    <section *ngIf="!loading; else showLoading">
        <section *ngIf="myRequests && myRequests.length > 0 else naoPossuiEmprestimos">
            <section class="content__header__table display-sm-none">
                <div class="col-xl-2">Contrato</div>
                <div class="col-xl-2">Situação</div>
                <div class="col-xl-2">Data do Crédito</div>
                <div class="col-xl-2">Saldo Devedor</div>
                <div class="col-xl-1">Parcelas</div>
                <div class="col-xl-2 text-center">Data Quitação</div>
                <div class="col-xl-1 text-center">Ações</div>
            </section>
            <section class="content__main__table">
                <div class="table__card" *ngFor="let item of myRequests; let firstItem = first">
                    <div class="col-xl-2 col-sm-2 display-header-card">
                        <div class="indice-legenda">
                            <span class="table__legenda__mobile">Contrato: </span>
                            <span>{{item.contractNumber | trim}}</span>
                        </div>
                        <div>
                            <a class="fa-icon" (click)="visualizarEmprestimo(item)">
                                <fa-icon [icon]="faEye"></fa-icon>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-2 col-sm-2 display-sm-none">
                        <span class="table__legenda__mobile">Contrato: </span>
                        <span>{{item.contractNumber | trim}}</span>
                    </div>
                    <div class="col-xl-2 col-sm-2">
                        <span class="table__legenda__mobile">Situação: </span>
                        <span>
                            <status [status]="item.status">
                            </status>
                        </span>
                    </div>
                    <div class="col-xl-2 col-sm-2">
                        <span class="table__legenda__mobile">Data do Crédito: </span>
                        <span>{{item.creditDate | date: 'dd/MM/yyyy'}}</span>
                    </div>
                    <div class="col-xl-2 col-sm-2">
                        <span class="table__legenda__mobile">Saldo Devedor: </span>
                        <span>R$ {{item.balanceLacking | number: "1.2-2":"pt-br"}}</span>
                    </div>
                    <div class="col-xl-1 col-sm-1">
                        <span class="table__legenda__mobile">Parcelas: </span>
                        <span>{{item.totalParcelCount-
                            item.totalParcelRemainingCount}}/{{item.totalParcelRemainingCount}}</span>
                    </div>
                    <div class="col-xl-2 col-sm-2 text-center">
                        <span class="table__legenda__mobile">Data Quitação: </span>
                        <span *ngIf="item.acquittanceDate else naoPossuiDataQuitacao">{{ item.acquittanceDate |
                            date:'dd/MM/yyyy'}}</span>
                        <ng-template #naoPossuiDataQuitacao>
                            <span class="text-center">
                                -
                            </span>
                        </ng-template>
                    </div>
                    <div class="col-xl-1 col-md-1 display-sm-none text-center">
                        <a class="fa-icon" (click)="visualizarEmprestimo(item)">
                            <fa-icon [icon]="faEye"></fa-icon>
                        </a>
                    </div>
                </div>
            </section>
        </section>
    </section>
</main>
<footer class="col-12 footer__content">
    <paginacao [currentPage]="1" [collectionSize]="tamanhoLista" [pageSize]="myRequestsFilter.itemsPerPage"
        (changeNumber)="onChangePagination($event)">
    </paginacao>
</footer>